import axios from 'axios';
import { buildHttpHeaders, getHttpErrorHandler, httpResponseHandler } from './http.utils';
export function getHttpClient(args) {
    var _a, _b;
    const axiosClient = axios.create({
        timeout: args.timeout || 10000,
        headers: {
            'x-anonymous-id': ((_b = (_a = global.analytics) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.call(_a).anonymousId()) || ''
        }
    });
    axiosClient.interceptors.response.use(httpResponseHandler, getHttpErrorHandler(args.unauthorizedCallback));
    return {
        get: async (url, options) => {
            return await axiosClient.get(url, {
                headers: buildHttpHeaders(options)
            });
        },
        post: async (url, data, options) => {
            return await axiosClient.post(url, data, {
                headers: buildHttpHeaders(options)
            });
        },
        put: async (url, data, options) => {
            return await axiosClient.put(url, data, {
                headers: buildHttpHeaders(options)
            });
        },
        patch: async (url, data, options) => {
            return await axiosClient.patch(url, data, {
                headers: buildHttpHeaders(options)
            });
        },
        delete: async (url, options) => {
            return await axiosClient.delete(url, {
                headers: buildHttpHeaders(options)
            });
        },
        deleteWithBody: async (url, data, options) => {
            return await axiosClient.request({
                url,
                data,
                method: 'DELETE',
                headers: buildHttpHeaders(options)
            });
        }
    };
}
//# sourceMappingURL=http.js.map